export enum BetsQueryKeys {
  Primary = '/bets',
  Me = '/bets/me',
  MeInfinity = 'infinite:bets/me',
  ById = '/bets/:id',
  BySlug = '/bets/slug/:slug',
  ByPlayer = '/bets/player/:playerId',
  ByRound = '/bets/round/:roundId',
  ByRoundInfinite = 'infinite:bets/round/:roundId',
  Ranking = '/bets/ranking',
  BetsOriginalsMe = '/bets/originals/me',
}
